import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE } from './constants';

class ServiceDueDetailsProvider extends BaseApi {
	async saveDueRemider(ServiceDue: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SaveDueRemider`, ServiceDue);
	}

	async GetServiceDueDetailsReport(parameter: any, columnsSeq: any, languageId: any) {
		// eslint-disable-next-line max-len
		return this.downloadXlsxReport(`/${DMS_MODULE}/${NAME}/GetServiceDueDetailsReport?${parameter}&ColumnSequence=${columnsSeq}&LanguageId=${languageId}`, 'ServiceDueDetails.xlsx');
	}
}

export const apiProvider = new ServiceDueDetailsProvider(DMS_MODULE, NAME);
